"use strict";

exports.__esModule = true;
exports.ActivitiesAggregatedChart = ActivitiesAggregatedChart;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _AggregateMetricChartController = require("../common/AggregateMetricCharts/AggregateMetricChartController");
var _ScrollableChart = require("../common/AggregateMetricCharts/ScrollableChart");
var _Spinner = require("../../Core/Spinner");
var _timeAggregationBinMapping = require("../../VIMANAMetrics/timeAggregationBinMapping");
var _ActivitiesChartDataFormatter = require("./dataFormatter/ActivitiesChartDataFormatter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function dataHandler(props) {
  return function (_ref) {
    var data = _ref.data,
      fetching = _ref.fetching;
    if (fetching) {
      return /*#__PURE__*/_react["default"].createElement(_Spinner.Spinner, null);
    }
    if (data.length === 0) {
      return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "Widgets.NoData.Warning",
        defaultMessage: "No Data Available"
      });
    }
    var _props$timeAggregatio = props.timeAggregationName,
      timeAggregationName = _props$timeAggregatio === void 0 ? "" : _props$timeAggregatio,
      _props$activityDetail = props.activityDetails,
      activityDetails = _props$activityDetail === void 0 ? [] : _props$activityDetail,
      _props$showTooltip = props.showTooltip,
      showTooltip = _props$showTooltip === void 0 ? true || false : _props$showTooltip,
      _props$selectedStates = props.selectedStates,
      selectedStates = _props$selectedStates === void 0 ? [] : _props$selectedStates,
      _props$selectedActivi = props.selectedActivities,
      selectedActivities = _props$selectedActivi === void 0 ? [] : _props$selectedActivi,
      tooltipSort = props.tooltipSort;
    try {
      return /*#__PURE__*/_react["default"].createElement(_ActivitiesChartDataFormatter.ActivitiesChartDataFormatter, {
        timeAggregationName: timeAggregationName,
        data: data,
        activityDetails: activityDetails,
        showTooltip: showTooltip,
        selectedStates: selectedStates,
        selectedActivities: selectedActivities,
        tooltipSort: tooltipSort
      }, function (_ref2) {
        var series = _ref2.series,
          totalMinorBar = _ref2.totalMinorBar;
        return series[0].data.length ? /*#__PURE__*/_react["default"].createElement(_ScrollableChart.ScrollableChart, _extends({}, props, {
          minorBarPerMajorBar: totalMinorBar,
          minorBarSize: 50,
          series: series,
          builtInTooltip: false
        })) : /*#__PURE__*/_react["default"].createElement(_Spinner.Spinner, null);
      });
    } catch (_unused) {
      return /*#__PURE__*/_react["default"].createElement("div", null);
    }
  };
}
function ActivitiesAggregatedChart(props) {
  var width = props.width,
    height = props.height,
    query = props.query;
  if (!query) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "ActivitiesSummaryChart",
      style: {
        width: width,
        height: height
      }
    }, dataHandler(props)({
      data: props.data,
      fetching: false
    }));
  }
  var timeAggregation = (0, _timeAggregationBinMapping.getTimeGroupingFromAgg)({
    aggregations: props.aggregations
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "ActivitiesAggregatedChart",
    style: {
      width: width,
      height: height
    }
  }, /*#__PURE__*/_react["default"].createElement(_AggregateMetricChartController.AggregateMetricChartController, {
    query: query
  }, dataHandler(Object.assign({}, props, {
    xAxisLabel: timeAggregation && timeAggregation.label
  }))));
}